import { useTemplateState } from './context/VideoTemplateStateContext';

export default function useSlide(id: string) {
  const { slideshow } = useTemplateState();
  return slideshow?.data?.[id];
}
